export default [
  {
    leerdoelen: [
      "1a",
      "1b",
      "1c",
      "1d",
      "1e",
      "1f",
      "1g",
      "1h",
      "1i",
      "1j",
      "1k",
      "1l",
      "1m",
      "1n",
      "1o",
      "1p",
      "1q",
      "1r",
      "1s",
      "1t"
    ],
    voorkennis: []
  },
  {
    leerdoelen: ["2a", "2b", "2c", "2d", "2e", "2f", "2g", "2h", "2i"],
    voorkennis: ["1q", "1r"]
  },
  {
    leerdoelen: ["3a", "3b", "3c", "3d", "3e", "3f", "3g", "3h"],
    voorkennis: ["1q", "1r"]
  },
  { leerdoelen: ["4a", "4b", "4c", "4d", "4e"], voorkennis: ["1q", "1r"] },
  { leerdoelen: ["5a", "5b", "5c", "5d"], voorkennis: [] },
  { leerdoelen: ["6a", "6b", "6c", "6d", "6e"], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: ["8a", "8b", "8c", "8d", "8e", "8f", "8g"],
    voorkennis: ["1a", "1d"]
  },
  {
    leerdoelen: ["9a", "9b", "9c", "9d", "9e", "9f", "9g", "9h"],
    voorkennis: []
  },
  {
    leerdoelen: [
      "10a",
      "10b",
      "10c",
      "10d",
      "10e",
      "10f",
      "10g",
      "10h",
      "10i",
      "10j",
      "10k"
    ],
    voorkennis: ["8a", "8b"]
  },
  { leerdoelen: ["11a", "11b", "11c", "11d"], voorkennis: ["8a"] },
  {
    leerdoelen: ["12a", "12b", "12c", "12d", "12e", "12f"],
    voorkennis: ["8b", "8d", "10e"]
  },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: ["15a", "15b", "15c", "15d", "15e", "15f"],
    voorkennis: ["5a", "5b", "5c"]
  },
  {
    leerdoelen: ["16a", "16b", "16c", "16d"],
    voorkennis: ["5a", "5b", "5c", "15a", "15c"]
  },
  { leerdoelen: ["17a", "17b"], voorkennis: ["3a", "16a", "16b"] },
  {
    leerdoelen: [
      "18a",
      "18b",
      "18c",
      "18d",
      "18e",
      "18f",
      "18g",
      "18h",
      "18i",
      "18j"
    ],
    voorkennis: ["16a"]
  },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: ["22a", "22b", "22c", "22d", "22e", "22f"],
    voorkennis: ["5c", "1m", "1n", "2c", "3d", "4c"]
  },
  { leerdoelen: ["23a", "23b", "23c", "23d", "23e", "23f"], voorkennis: [] },
  {
    leerdoelen: ["24a", "24b", "24c", "24d", "24e", "24f", "24g"],
    voorkennis: ["22e", "22f"]
  },
  {
    leerdoelen: ["25a", "25b", "25c", "25d", "25e", "25f", "25g"],
    voorkennis: ["1e"]
  },
  {
    leerdoelen: ["26a", "26b", "26c", "26d"],
    voorkennis: ["10k", "25b", "25c", "25d", "25f", "25g"]
  },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: ["29a", "29b", "29c", "29d", "29e", "29f", "29g", "29h", "29i"],
    voorkennis: ["8a", "8b", "8d", "10e", "12c"]
  },
  {
    leerdoelen: ["30a", "30b", "30c", "30d", "30e"],
    voorkennis: ["29a", "8b", "8d", "10e", "10f", "29c"]
  },
  {
    leerdoelen: ["31a", "31b", "31c", "31d", "31e"],
    voorkennis: ["29a", "8b", "9a", "9b", "15e"]
  },
  {
    leerdoelen: ["32a", "32b", "32c", "32d", "32e", "32f"],
    voorkennis: ["8a", "10f", "29c", "10g", "11b", "31c", "31d"]
  },
  {
    leerdoelen: ["33a", "33b", "33c", "33d", "33e", "33f", "33g", "33h", "33i"],
    voorkennis: ["25b", "25c", "25d", "25e", "26c", "26d", "8b", "10k", "31a"]
  },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: ["36a", "36b", "36c", "36d", "36e"],
    voorkennis: ["5a", "5b", "15a", "5c", "5d"]
  },
  {
    leerdoelen: ["37a", "37b", "37c", "37d", "37e"],
    voorkennis: ["15c", "16c", "16d", "17a", "22b"]
  },
  {
    leerdoelen: ["38a", "38b", "38c", "38d", "38e", "38f"],
    voorkennis: ["8b", "16c", "16d"]
  },
  {
    leerdoelen: ["39a", "39b", "39c"],
    voorkennis: ["31a", "15e", "16d", "25e"]
  },
  {
    leerdoelen: [
      "40a",
      "40b",
      "40c",
      "40d",
      "40e",
      "40f",
      "40g",
      "40h",
      "40i",
      "40j",
      "40k"
    ],
    voorkennis: ["15e", "22b"]
  },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: ["43a", "43b", "43c", "43d", "43e", "43f", "43g"],
    voorkennis: ["8a", "30b", "8b", "10e"]
  },
  {
    leerdoelen: [
      "44a",
      "44b",
      "44c",
      "44d",
      "44e",
      "44f",
      "44g",
      "44h",
      "44i",
      "44j",
      "44k",
      "44m"
    ],
    voorkennis: ["8a", "30b", "8b", "12c", "31a", "10e", "43d", "43e", "6d"]
  },
  {
    leerdoelen: ["45a", "45b", "45c", "45d", "45e", "45f", "45g"],
    voorkennis: ["44c"]
  },
  { leerdoelen: ["46a", "46b", "46c", "46d", "46e"], voorkennis: ["22b"] },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: ["50a", "50b", "50c", "50d", "50e"],
    voorkennis: ["30b", "8b", "31a", "10f", "29c", "43d", "43e"]
  },
  {
    leerdoelen: ["51a", "51b"],
    voorkennis: ["38a", "38b", "31a", "31b", "38e", "39a", "38f", "39a", "39b"]
  },
  {
    leerdoelen: ["52a", "52b", "52c", "52d"],
    voorkennis: [
      "38a",
      "38b",
      "31a",
      "31b",
      "38e",
      "39a",
      "38f",
      "39a",
      "51a",
      "51b"
    ]
  },
  { leerdoelen: [], voorkennis: [] },
  {
    leerdoelen: [
      "54a",
      "54b",
      "54c",
      "54d",
      "54e",
      "54f",
      "54g",
      "54h",
      "54i",
      "54j"
    ],
    voorkennis: ["8b", "44f", "44g", "22b"]
  },
  { leerdoelen: [], voorkennis: [] },
  { leerdoelen: [], voorkennis: [] }
];



// WEBPACK FOOTER //
// ./src/data/hoofdstukken-latijn.js